"use client";

import dynamic from 'next/dynamic';
import { useIsMobile } from "@/hooks/use-mobile";
import { Loader2 } from "lucide-react";
import { Facture, Devis } from "@/types";

const DesktopInvoiceEditor = dynamic(() => import("./DesktopInvoiceEditor").then(mod => mod.DesktopInvoiceEditor), {
    loading: () => <div className="flex items-center justify-center min-h-[400px]"><Loader2 className="h-8 w-8 animate-spin text-muted-foreground" /></div>,
    ssr: false
});

const MobileDocumentPage = dynamic(() => import("../mobile/features/MobileDocumentPage").then(mod => mod.MobileDocumentPage), {
    loading: () => <div className="flex items-center justify-center min-h-[400px]"><Loader2 className="h-8 w-8 animate-spin text-muted-foreground" /></div>,
    ssr: false
});

export function InvoiceEditor(props: { type?: "Facture" | "Devis", initialData?: Facture | Devis }) {
    const isMobile = useIsMobile();
    const documentId = props.initialData?.id || 'new';

    if (isMobile) {
        return <MobileDocumentPage
            key={`mobile-${documentId}`}
            type={props.type === "Facture" ? "FACTURE" : "DEVIS"}
            id={props.initialData?.id}
            initialMode="edit"
        />;
    }

    return <DesktopInvoiceEditor key={`desktop-${documentId}`} {...props} />;
}
